/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

export interface AIResponse {
  role: 'assistant';
  content: string;
  input?: string;
}

export type MultiRowTableContext = Record<string, string | number | undefined>[];

export interface AdditionalContext {
  inputData?: MultiRowTableContext;
}

export interface AIConfig {
  additionalContext: string;
  aiModel?: AIModel;
}

export enum AIModel {
  GPT_5 = 'gpt-5',
  Claude_3_5 = 'claude-3.5',
}

export const AIModelInfoMap: { [key in AIModel]: { label: string; icon?: string } } = {
  [AIModel.GPT_5]: {
    label: 'GPT-5',
    icon: 'fa-brands fa-openai',
  },
  [AIModel.Claude_3_5]: {
    label: 'Claude 3.5',
  },
};

export enum AiProcessingValue {
  Include = 'include',
  Exclude = 'exclude',
}
